import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
  en: {
    translation: {
      thankYouTitle: "Thank You!",
      thankYouMessage: "Your application has been submitted successfully.",
      backHome: " Back to Home",
      back: "Back",
      next: "Next",
      submit: "Submit",
      yes: "Yes",
      no: "No",
      mr: "Mr",
      ms: "Ms/Mrs",
      choose: "Choose...",
      header: {
        title: "COP29 Green Zone Media Accreditation ",
        subtitle:
          "This portal is designed to facilitate the accreditation process for journalists, media professionals and other representatives of the press to submit their accreditation requests for the COP29 Green Zone. ",
        guide1: `Please review the `,
        guide2: `User Guide`,
        guide3: ` thoroughly before completing and submitting your application.`,

        deadline: "Application Deadline:",
        deadline2: "30 October at 11:00 PM (GMT+4)",

        questions:
          "Should you have any questions or need assistance, please contact us at ",
        questionsMail:
          "mediaaccreditation@cop29.az",
        questionsMail2: "",
        mandatory: "Fields marked with an (*) are mandatory.",
      },
      emailVerification: {
        title: "Email Verification",
        email: "Email",
        emailText: "Please enter your email address to receive an OTP",

        language: "Select email notification language",
        AZ: "Azerbaijani",
        EN: "English",
        nationality: "Nationality",
        mediaType: "Media Type",
        next: "Next",
        mediaTypes: {
          TV: "TV",
          RADIO: "Radio",
          AGENCY: "Agency",
          PUBLICATION: "Publication",
          WEBSITE: "Website",
          NEWSPAPER: "Newspaper",
          MAGAZINE: "Magazine",
          PHOTO_AGENCY: "Photo Agency",
          NEWS_AGENCY: "News Agency",
          ONLINE_MEDIA: "Online Media",
          OTHER: "Other",
        },
      },
      otpVerification: {
        otp: "OTP",
        otpText: "Enter OTP code sent to your email",
        resend: "Resend OTP",
        verify: "Verify",
        resendIn: "OTP expires in",
        resendIn2: ""

      },
      personalInformation: {
        title: "Title",
        firstName: "First Name",
        lastName: "Last Name",
        fatherName: "Father's Name",
        gender: "Gender",
        dateOfBirth: "Date of Birth",
        placeOfBirth: "Place of Birth",
        nationality: "Nationality",
        residenceCountry: "Residence Country",
        residenceCity: "Residence City",
        idNumber: "National ID Number / Passport Number",
        finCode: "PIN Code",
        address: "Address",
        mobile: "Mobile",
        email: "Email",
        datePicker: "dd/mm/yyyy",
        labels: {
          day: "Day",
          month: "Month",
          year: "Year"
        },
        participation:
          "Have you ever attended an international mega event before?",
        experience: "If yes, please provide the name of the event and a short description of your experience.",
        describeExperience:
          "If yes, please provide the name of the event and a short description of your experience.",
        disability:
          "Are you a person with disabilities who requires support services to participate at COP29?",
        disabilityDescription:
          "If yes, please describe the type of service you would require.",
        comments: "Additional Comments",
        // Media-Specific Fields:
        organization: "Organisation",
        department: "Department",
        jobTitle: "Job Title",
        companyAddress: "Company Address",
        city: "City",
        postalCode: "Postal Code",
        companyPhone1: "Company Phone 1",
        companyPhone2: "Company Phone 2",
        companyMobile: "Company Mobile",
        companyEmail: "Company Email",
        mediaEquipment: "Do you have any media equipment?",
        websiteAddress: "Website Address",
        webVisitors: "Web Visitors",
        cop29Section: "Does the website contain original news content on climate change?",
        organizationComments: "Additional comments",
        url: "URL",
        publicationName: "Publication Name",
        frequency: "Frequency",
        frequencyOther: "Specify Frequency",
        circulation: "Circulation/Visitors",
        dragAndDrop: "Drag and drop file here or Click to upload",
        selectedFile: "Selected file",
        formalApplicationLetter:
          "Letter of Assignment ",
        formalApplicationLetterLink:
          "(download template here)",

        passportSizePhoto: "Passport-sized photo (3x4 cm)",
        registerCertificate: "Media Register Certificate",
        registerNote: "This document is mandatory only for local media representatives.",
        pressCardScan: "Scan of Press Card",
        idScan: "Scan of National ID or Passport",
        agreeToShareInfo:
          "I agree that the information I have submitted in this request will be shared with the relevant authorities.",
        confirmAccuracy:
          "I confirm that the information I have provided in this request is accurate and complete, and I accept full responsibility for its accuracy and any consequences that may arise.",
        submit: "Submit",
        // Additional Translations
        uploadDocuments: "Upload Documents",
        personalInfo: "Personal Information",
        organizationSec: "Organisation",
        frequencyOptions: {
          DAILY: "Daily",
          WEEKLY: "Weekly",
          MONTHLY: "Monthly",
          OTHER: "Other",
        },
        genderOptions: {
          MALE: "Male",
          FEMALE: "Female",
          PREFER_NOT_TO_SAY: "Prefer not to say",
        },
        mediaTypeDescription: "If 'Other', please Specify",
        allowedFileTypes: "Allowed file types",
        maxFileSize: "Max. file size",
        departmentExplanation: 'A participant\'s Department is their specific subsection within their Organisation. Please enter "Not Applicable" in cases where you do not have a specific department.'
      },
      validation: {
        recaptchaEmpty: "Recaptcha can not be empty",
        verifyOtp: "Verification failed. Please try again.",
        validAttachment: "File is missing",
        validEmailFields: "Please fill in all required fields.",
        validEmail: "Please enter a valid email address.",
        validLanguage: "Please choose a language for email notification.",
        nationalityrequired: "Nationality is required.",
        typeRequired: "Media type is required.",
        emailRequired: "Email is required.",
        recaptchaValid: "Recaptcha must be checked.",
        title: "Title can not be empty.",
        firstName: "First Name can not be empty.",
        lastName: "Last Name can not be empty.",
        fatherName: "Father's Name can not be empty.",
        gender: "Gender can not be empty.",
        dateOfBirth: "Date of Birth can not be empty.",
        invalidDateFormat: "Date format is incorrect.",
        placeOfBirth: "Place of Birth can not be empty.",
        nationality: "Nationality can not be empty.",
        residenceCountry: "Residence Country can not be empty.",
        residenceCity: "Residence City can not be empty.",
        idNumber: "National ID Number / Passport Number can not be empty.",
        finCode: "PIN Code can not be empty.",
        address: "Address can not be empty.",
        mobile: "Mobile can not be empty.",
        email: "Email can not be empty.",
        participation: "Participation can not be empty.",
        experience: "Experience details can not be empty.",
        describeExperience: "Description of your experience can not be empty.",
        disability: "Disability option can not be empty.",
        disabilityDescription: "Disability description can not be empty.",
        organization: "Organisation can not be empty.",
        organizationDepartment: "Department can not be empty.",
        field: "This field is required.",
        organizationJobTitle: "Job title can not be empty.",
        organizationAddress: "Address can not be empty.",
        organizationCity: "City can not be empty.",
        organizationPostalCode: "Postal code can not be empty.",
        organizationPhone1: "Organisation's phone can not be empty.",
        organizationEmail: "This is not a valid email format",
        media: "Media equipment can not be empty.",
        copUrl: "Url can not be empty.",
        websiteAddress: "Website address can not be empty.",
        webVisitors: "Website visitors can not be empty and should be a number.",
        cop29: "COP29 section can not be empty.",
        publicationName: "Publication name can not be empty.",
        frequency: "Frequency cannot be empty.",
        frequencyOther: "Frequency cannot be empty.",
        circulation: "This field is required and must be a number.",
      },
      countries: {
        AFG: "Afghanistan",
        ALB: "Albania",
        ALG: "Algeria",
        AND: "Andorra",
        ANG: "Angola",
        ANT: "Antigua and Barbuda",
        ARG: "Argentina",
        ARM: "Armenia",
        AUS: "Australia",
        AUT: "Austria",
        AZE: "Azerbaijan",
        BAH: "Bahamas",
        BRN: "Bahrain",
        BAN: "Bangladesh",
        BAR: "Barbados",
        BLR: "Belarus",
        BEL: "Belgium",
        BIZ: "Belize",
        BEN: "Benin",
        BHU: "Bhutan",
        BOL: "Bolivia (Plurinational State of)",
        BIH: "Bosnia and Herzegovina",
        BOT: "Botswana",
        BRA: "Brazil",
        BRU: "Brunei Darussalam",
        BUL: "Bulgaria",
        BUR: "Burkina Faso",
        BDI: "Burundi",
        CPV: "Cabo Verde",
        CAM: "Cambodia",
        CMR: "Cameroon",
        CAN: "Canada",
        CAF: "Central African Republic",
        CHA: "Chad",
        CHI: "Chile",
        CHN: "China",
        COL: "Colombia",
        COM: "Comoros",
        COD: "Democratic Republic of the Congo",
        COK: "Cook Islands",
        CRC: "Costa Rica",
        CIV: "Cote d'Ivoire",
        CRO: "Croatia",
        CUB: "Cuba",
        CYP: "Cyprus",
        CZE: "Czechia",
        DEN: "Denmark",
        DJI: "Djibouti",
        DMA: "Dominica",
        DOM: "Dominican Republic",
        ECU: "Ecuador",
        EGY: "Egypt",
        ESA: "El Salvador",
        GEQ: "Equatorial Guinea",
        ERI: "Eritrea",
        EST: "Estonia",
        ETH: "Ethiopia",
        FIJ: "Fiji",
        FIN: "Finland",
        FRA: "France",
        GAB: "Gabon",
        GAM: "Gambia",
        GEO: "Georgia",
        GER: "Germany",
        GHA: "Ghana",
        GRE: "Greece",
        GRN: "Grenada",
        GUA: "Guatemala",
        GUI: "Guinea",
        GBS: "Guinea-Bissau",
        GUY: "Guyana",
        HAI: "Haiti",
        HON: "Honduras",
        HUN: "Hungary",
        ISL: "Iceland",
        IND: "India",
        INA: "Indonesia",
        IRI: "Iran (Islamic Republic of)",
        IRQ: "Iraq",
        IRL: "Ireland",
        ISR: "Israel",
        ITA: "Italy",
        JAM: "Jamaica",
        JPN: "Japan",
        JOR: "Jordan",
        KAZ: "Kazakhstan",
        KEN: "Kenya",
        KIR: "Kiribati",
        KUW: "Kuwait",
        KGZ: "Kyrgyzstan",
        LAO: "Lao People's Democratic Republic",
        LAT: "Latvia",
        LIB: "Lebanon",
        LES: "Lesotho",
        LBR: "Liberia",
        LBA: "Libya",
        LIE: "Liechtenstein",
        LTU: "Lithuania",
        LUX: "Luxembourg",
        MKD: "North Macedonia",
        MAD: "Madagascar",
        MAW: "Malawi",
        MAS: "Malaysia",
        MDV: "Maldives",
        MLI: "Mali",
        MLT: "Malta",
        MHL: "Marshall Islands",
        MTN: "Mauritania",
        MRI: "Mauritius",
        MEX: "Mexico",
        FSM: "Micronesia (Federated States of)",
        MDA: "Republic of Moldova",
        MON: "Monaco",
        MGL: "Mongolia",
        MNE: "Montenegro",
        MAR: "Morocco",
        MOZ: "Mozambique",
        MYA: "Myanmar",
        NAM: "Namibia",
        NRU: "Nauru",
        NEP: "Nepal",
        NED: "Netherlands",
        NZL: "New Zealand",
        NCA: "Nicaragua",
        NIG: "Niger",
        NGR: "Nigeria",
        NIU: "Niue",
        PFK: "Democratic People's Republic of Korea",
        NOR: "Norway",
        OMA: "Oman",
        PAK: "Pakistan",
        PLW: "Palau",
        PLE: "State of Palestine",
        PAN: "Panama",
        PNG: "Papua New Guinea",
        PAR: "Paraguay",
        PER: "Peru",
        PHI: "Philippines",
        POL: "Poland",
        POR: "Portugal",
        QAT: "Qatar",
        ROU: "Romania",
        RUS: "Russian Federation",
        RWA: "Rwanda",
        SKN: "Saint Kitts and Nevis",
        LCA: "Saint Lucia",
        VIN: "Saint Vincent and the Grenadines",
        SAM: "Samoa",
        SMR: "San Marino",
        STP: "Sao Tome and Principe",
        KSA: "Saudi Arabia",
        SEN: "Senegal",
        SRB: "Serbia",
        SEY: "Seychelles",
        SLE: "Sierra Leone",
        SIN: "Singapore",
        SVK: "Slovakia",
        SLO: "Slovenia",
        SOL: "Solomon Islands",
        SOM: "Somalia",
        RSA: "South Africa",
        KOR: "Republic of Korea",
        SSD: "South Sudan",
        ESP: "Spain",
        SRI: "Sri Lanka",
        SUD: "Sudan",
        SUR: "Suriname",
        SWZ: "Eswatini",
        SWE: "Sweden",
        SUI: "Switzerland",
        SYR: "Syrian Arab Republic",
        TJK: "Tajikistan",
        TAN: "United Republic of Tanzania",
        THA: "Thailand",
        TLS: "Timor-Leste",
        TOG: "Togo",
        TGA: "Tonga",
        TRI: "Trinidad and Tobago",
        TUN: "Tunisia",
        TUR: "Türkiye",
        TKM: "Turkmenistan",
        TUV: "Tuvalu",
        UGA: "Uganda",
        UKR: "Ukraine",
        UAE: "United Arab Emirates",
        GBR: "United Kingdom of Great Britain and Northern Ireland",
        USA: "United States of America",
        URU: "Uruguay",
        UZB: "Uzbekistan",
        VAN: "Vanuatu",
        VAT: "Holy See",
        VEN: "Venezuela (Bolivarian Republic of)",
        VIE: "Viet Nam",
        YEM: "Yemen",
        ZAM: "Zambia",
        ZIM: "Zimbabwe",
      },
    },
  },
  az: {
    translation: {
      thankYouTitle: "Təşəkkür edirik!",
      thankYouMessage: "Müraciətiniz uğurla tamamlandı.",
      backHome: "Əsas səhifəyə qayıt",
      back: "Geri",
      next: "Növbəti",
      submit: "Müraciəti göndər",
      yes: "Bəli",
      no: "Xeyr",
      choose: "Seçin...",
      mr: "Cənab",
      ms: "Xanım",
      header: {
        title: "COP29 Yaşıl Zona Media Akkreditasiyası",
        subtitle:
          " Bu portal jurnalistlər, media peşəkarları və digər mətbuat nümayəndələrinin COP29 Yaşıl Zona Media Akkreditasiyasına müraciət etmələri üçün yaradılmışdır.",
        guide1:
          "Müraciətinizi göndərmədən əvvəl ",
        guide2: `İstifadəçi təlimatını`,
        guide3: ` diqqətlə nəzərdən keçirməyiniz xahiş olunur.`,

        deadline: "Müraciət üçün son tarix: ",
        deadline2: "30 oktyabr, saat 23:00 (GMT+4)",
        questions:
          "Hər hansı sualınız yaranarsa və ya əlavə dəstək tələb olunarsa, ",
        questionsMail:
          "mediaaccreditation@cop29.az",
        questionsMail2: " e-poçt ünvanı ilə əlaqə saxlaya bilərsiniz.",
        mandatory: "(*) ilə işarələnmiş xanalar mütləq doldurulmalıdır",
      },
      emailVerification: {
        title: "E-poçt doğrulama",
        email: "E-poçt",
        emailText: "OTP kodun göndərilməsi üçün e-poçt ünvanınızı daxil edin",
        language: "E-poçt bildiriş dilini seçin",
        AZ: "Azərbaycan",
        EN: "İngilis",
        nationality: "Vətəndaşlıq",
        mediaType: "Medianın növü",
        next: "Növbəti",
        mediaTypes: {
          TV: "TV",
          RADIO: "Radio",
          AGENCY: "Agentlik",
          PUBLICATION: "Nəşriyyat",
          WEBSITE: "Vebsayt",
          NEWSPAPER: "Qəzet",
          MAGAZINE: "Jurnal",
          PHOTO_AGENCY: "Fotoagentlik",
          NEWS_AGENCY: "İnformasiya agentliyi",
          ONLINE_MEDIA: "Onlayn media",
          OTHER: "Digər",
        },
      },
      otpVerification: {
        otp: "OTP",
        otpText: "E-poçt ünvanınıza göndərilən OTP kodunu daxil edin",
        resend: "OTP kodunu yenidən göndər",
        verify: "Təsdiq et",
        resendIn: "OTP",
        resendIn2: "dəqiqə ərzində aktivdir"
      },
      personalInformation: {
        title: "Müraciət forması",
        firstName: "Ad",
        lastName: "Soyad",
        fatherName: "Ata adı",
        gender: "Cins",
        dateOfBirth: "Doğum tarixi",
        placeOfBirth: "Doğum yeri",
        nationality: "Vətəndaşlıq",
        residenceCountry: "Yaşadığı ölkə",
        residenceCity: "Yaşadığı şəhər",
        idNumber: "Şəxsiyyət vəsiqəsinin nömrəsi/Pasport nömrəsi",
        finCode: "FİN kod",
        address: "Ünvan",
        mobile: "Mobil",
        email: "E-poçt",
        datePicker: "gün/ay/il",
        labels: {
          day: "Gün",
          month: "Ay",
          year: "İl"
        },
        participation:
          "Siz daha əvvəl hər hansı bir beynəlxalq irimiqyaslı tədbirdə iştirak etmisinizmi?",
        experience:
          "İştirak etmisinizsə, tədbirin adını və təcrübəniz haqqında qısa məlumatı təqdim edin.",
        describeExperience: "Təcrübənizi qısaca təsvir edin",
        disability:
          "COP29-da iştirak etmək üçün xüsusi dəstək xidmətlərini zəruri edən fiziki/əqli məhdudiyyətiniz varmı? ",
        disabilityDescription:
          "Əgər belədirsə, tələb olunan xidmət növünü qeyd edin.",
        comments: "Əlavə qeydlər",
        //Media specific fields:
        organization: "Şirkətin adı",
        department: "Şöbə",
        jobTitle: "Vəzifəsi",
        companyAddress: "Şirkətin ünvanı",
        city: "Şəhər",
        postalCode: "Poçt indeksi",
        companyPhone1: "Şirkətin əlaqə nömrəsi - 1",
        companyPhone2: "Şirkətin əlaqə nömrəsi - 2",
        companyMobile: "Şirkətin mobil nömrəsi",
        companyEmail: "Şirkətin e-poçt ünvanı",
        mediaEquipment: "Hər hansı media avadanlığınız varmı?",
        websiteAddress: "Vebsaytın internet ünvanı (url)",
        webVisitors: "Vebsaytın ziyarətçi sayı",
        cop29Section: "Vebsaytda iqlim dəyişiklikləri ilə bağlı orijinal xəbər məzmunu varmı?",
        url: "URL",
        publicationName: "Nəşriyyat orqanının adı",
        frequency: "Dövriyyəsi",
        frequencyOther: "Digər dövriyyə",
        circulation: "Tiraj /ziyarətçi sayı",
        organizationComments: "Əlavə qeydlər",
        dragAndDrop:
          "Faylı sürüşdürün və ya yükləmək üçün klikləyin",
        selectedFile: "Faylı seç",
        formalApplicationLetter:
          "Xidməti ezamiyyət məktubu ",
        formalApplicationLetterLink:
          "(şablonu buradan yükləyin)",
        passportSizePhoto: "Pasport ölçüsünə uyğun fotoşəkil  (3x4 sm)",
        registerCertificate: "Media Reyestri şəhadətnaməsi",
        registerNote: "Bu sənəd yalnız yerli media nümayəndələri üçün zəruridir.",
        pressCardScan: "Jurnalist vəsiqəsinin skan edilmiş surəti",
        idScan: "Şəxsiyyət vəsiqəsinin və ya pasportun skan edilmiş surəti",
        agreeToShareInfo:
          "Mən təqdim etdiyim məlumatların müvafiq dövlət orqanları ilə paylaşılmasına razılıq verirəm.",
        confirmAccuracy:
          "Təqdim etdiyim məlumatların tam və dəqiq olduğunu təsdiq edirəm. Məlumatların düzgünlüyünə və yarana biləcək bütün nəticələrə görə məsuliyyət daşıyıram.",
        submit: "Müraciətinizi təsdiqləyin",
        uploadDocuments: "Tələb olunan sənədlər",
        personalInfo: "Şəxsi məlumatlar",
        organizationSec: "Təşkilat haqqında məlumatlar",
        frequencyOptions: {
          DAILY: "Gündəlik",
          WEEKLY: "Həftəlik",
          MONTHLY: "Aylıq",
          OTHER: "Digər",
        },
        genderOptions: {
          MALE: "Kişi",
          FEMALE: "Qadın",
          PREFER_NOT_TO_SAY: "Deməməyə üstünlük verirəm",
        },
        mediaTypeDescription: 'Əgər "Digər" seçilibsə, zəhmət olmasa qeyd edin.',
        allowedFileTypes: "İcazə verilən fayl növləri",
        maxFileSize: "Maksimum fayl ölçüsü",
        departmentExplanation: '"Şöbə" iştirakçının təmsil etdiyi təşkilatın xüsusi alt bölməsidir. Hər hansı bir departamenti təmsil etmədiyiniz halda “Uyğun deyil” yazın.'
      },
      validation: {
        recaptchaEmpty: "Recaptcha boş ola bilməz.",
        verifyOtp: "OTP-ni təsdiq etmək mümkün olmadı. Zəhmət olmasa yenidən cəhd edin.",
        validAttachment: "Zəhmət olmasa, fayl yükləyin",
        validEmailFields: "Zəhmət olmasa, bütün xanaları doldurun.",
        validEmail: "Zəhmət olmasa, düzgün e-poçt ünvanı daxil edin.",
        validLanguage: "Zəhmət olmasa, e-poçt bildirişi üçün bir dil seçin.",
        nationalityrequired: "Vətəndaşlıq zəruridir.",
        typeRequired: "Media növü zəruridir.",
        emailRequired: "E-poçt ünvanı zəruridir.",
        recaptchaValid: "Recaptcha xanasını doldurun.",
        title: "Müraciət forması boş ola bilməz.",
        firstName: "Ad boş ola bilməz.",
        lastName: "Soyad boş ola bilməz.",
        fatherName: "Ata adı boş ola bilməz.",
        gender: "Cins boş ola bilməz.",
        dateOfBirth: "Doğum tarixi boş ola bilməz.",
        invalidDateFormat: "Tarix formatı yanlışdır",
        placeOfBirth: "Doğum yeri boş ola bilməz.",
        nationality: "Vətəndaşlıq boş ola bilməz.",
        residenceCountry: "Yaşadığı ölkə boş ola bilməz.",
        residenceCity: "Yaşadığı şəhər boş ola bilməz.",
        idNumber:
          "Şəxsiyyət vəsiqəsinin nömrəsi/Pasport nömrəsi boş ola bilməz.",
        finCode: "FIN Kod boş ola bilməz.",
        address: "Ünvan boş ola bilməz.",
        mobile: "Mobil boş ola bilməz.",
        email: "E-poçt boş ola bilməz.",
        participation: "Boş ola bilməz.",
        experience: "Təcrübə boş ola bilməz.",
        describeExperience: "Təcrübənin qısaca təsviri boş ola bilməz.",
        disability: "Boş ola bilməz.",
        disabilityDescription: "Boş ola bilməz.",
        organization: "Boş ola bilməz.",
        organizationDepartment: "Boş ola bilməz.",
        field: "Bu xana doldurulmalıdır.",
        organizationJobTitle: "Boş ola bilməz.",
        organizationAddress: "Boş ola bilməz.",
        organizationCity: "Şəhər boş ola bilməz.",
        organizationPostalCode: "Poçt kodu boş ola bilməz.",
        organizationPhone1: "Şirkətin nömrəsi - 1 boş ola bilməz.",
        organizationEmail: "E-poçt formatı düzgün deyil.",
        media: "Media avadanlığ boş ola bilməz.",
        copUrl: "Url boş ola bilməz.",
        websiteAddress: "Vebsaytın adresi boş ola bilməz.",
        webVisitors: "Vebsaytın ziyarətçi sayı boş ola bilməz və rəqəm olmalıdır.",
        cop29: "COP29 Bölməsi boş ola bilməz.",
        publicationName: "Nəşrin adı boş ola bilməz.",
        frequency: "Nəşrin dövriyyəsi boş ola bilməz.",
        frequencyOther: "Digər dövriyyə boş ola bilməz.",
        circulation: "Bu xana doldurulmalıdır və yalnız rəqəmdən ibarət olmalıdır.",
      },
      countries: {
        AFG: "Əfqanıstan",
        ALB: "Albaniya",
        ALG: "Əlcəzair",
        AND: "Andorra",
        ANG: "Anqola",
        ANT: "Antiqua və Barbuda",
        ARG: "Argentina",
        ARM: "Ermənistan",
        AUS: "Avstraliya",
        AUT: "Avstriya",
        AZE: "Azərbaycan",
        BAH: "Baham adaları",
        BRN: "Bəhreyn",
        BAN: "Banqladeş",
        BAR: "Barbados",
        BLR: "Belarus",
        BEL: "Belçika",
        BIZ: "Beliz",
        BEN: "Benin",
        BHU: "Butan",
        BOL: "Boliviya",
        BIH: "Bosniya və Herseqovina",
        BOT: "Botsvana",
        BRA: "Braziliya",
        BRU: "Bruney",
        BUL: "Bolqarıstan",
        BUR: "Burkina Faso",
        BDI: "Burundi",
        CPV: "Kabo-Verde",
        CAM: "Kamboca",
        CMR: "Kamerun",
        CAN: "Kanada",
        CAF: "Mərkəzi Afrika Respublikası",
        CHA: "Çad",
        CHI: "Çili",
        CHN: "Çin Respublikası",
        COL: "Kolumbiya",
        COM: "Komor adaları",
        COD: "KDR",
        COK: "Kuk Adaları",
        CRC: "Kosta-Rika",
        CIV: "Kot-d’İvuar",
        CRO: "Xorvatiya",
        CUB: "Kuba",
        CYP: "Kipr",
        CZE: "Çexiya",
        DEN: "Danimarka",
        DJI: "Cibuti",
        DMA: "Dominika",
        DOM: "Dominikan Respublikası",
        ECU: "Ekvador",
        EGY: "Misir",
        ESA: "Salvador",
        GEQ: "Ekvatorial Qvineya",
        ERI: "Eritreya",
        EST: "Estoniya",
        ETH: "Efiopiya",
        FIJ: "Fici",
        FIN: "Finlandiya",
        FRA: "Fransa",
        GAB: "Qabon",
        GAM: "Qambiya",
        GEO: "Gürcüstan",
        GER: "Almaniya",
        GHA: "Qana",
        GRE: "Yunanıstan",
        GRN: "Qrenada",
        GUA: "Qvatemala",
        GUI: "Qvineya",
        GBS: "Qvineya-Bisau",
        GUY: "Qayana",
        HAI: "Haiti",
        HON: "Honduras",
        HUN: "Macarıstan",
        ISL: "İslandiya",
        IND: "Hindistan",
        INA: "İndoneziya",
        IRI: "İran",
        IRQ: "İraq",
        IRL: "İrlandiya",
        ISR: "İsrail",
        ITA: "İtaliya",
        JAM: "Yamayka",
        JPN: "Yaponiya",
        JOR: "İordaniya",
        KAZ: "Qazaxıstan",
        KEN: "Keniya",
        KIR: "Kiribati",
        KUW: "Küveyt",
        KGZ: "Qırğızıstan",
        LAO: "Laos",
        LAT: "Latviya",
        LIB: "Livan",
        LES: "Lesoto",
        LBR: "Liberiya",
        LBA: "Liviya",
        LIE: "Lixtenşteyn",
        LTU: "Litva",
        LUX: "Lüksemburq",
        MKD: "Makedoniya",
        MAD: "Madaqaskar",
        MAW: "Malavi",
        MAS: "Malayziya",
        MDV: "Maldiv adaları",
        MLI: "Mali",
        MLT: "Malta",
        MHL: "Marşall adaları",
        MTN: "Mavritaniya",
        MRI: "Mavriki",
        MEX: "Meksika",
        FSM: "Mikroneziya",
        MDA: "Moldova",
        MON: "Monako",
        MGL: "Monqolustan",
        MNE: "Monteneqro",
        MAR: "Mərakeş",
        MOZ: "Mozambik",
        MYA: "Myanma",
        NAM: "Namibiya",
        NRU: "Nauru",
        NEP: "Nepal",
        NED: "Niderland",
        NZL: "Yeni Kaledoniya",
        NCA: "Nikaraqua",
        NIG: "Niger",
        NGR: "Nigeriya",
        NIU: "Niue",
        PFK: "KXDR",
        NOR: "Norveç",
        OMA: "Oman",
        PAK: "Pakistan",
        PLW: "Palau",
        PLE: "Fələstin Dövləti",
        PAN: "Panama",
        PNG: "Papua Yeni Qvineya",
        PAR: "Paraqvay",
        PER: "Peru",
        PHI: "Filippin",
        POL: "Polşa",
        POR: "Portuqaliya",
        QAT: "Qətər",
        ROU: "Rumıniya",
        RUS: "Rusiya",
        RWA: "Ruanda",
        SKN: "Sent-Kits və Nevis",
        LCA: "Sent-Lüsiya",
        VIN: "Sent-Vinsent və Qrenadina",
        SAM: "Samoa",
        SMR: "San-Marino",
        STP: "San-Tome və Prinsipi",
        KSA: "Səudiyyə Ərəbistanı",
        SEN: "Seneqal",
        SRB: "Serbiya",
        SEY: "Seyşel adaları",
        SLE: "Syerra-Leone",
        SIN: "Sinqapur",
        SVK: "Slovakiya",
        SLO: "Sloveniya",
        SOL: "Solomon adaları",
        SOM: "Somali",
        RSA: "CAR",
        KOR: "Koreya Respublikası",
        SSD: "Cənubi Sudan",
        ESP: "İspaniya",
        SRI: "Şri-Lanka",
        SUD: "Sudan",
        SUR: "Surinam",
        SWZ: "Svazilend",
        SWE: "İsveç",
        SUI: "İsveçrə",
        SYR: "Suriya",
        TJK: "Tacikistan",
        TAN: "Tanzaniya",
        THA: "Tailand",
        TLS: "Şərqi Timor",
        TOG: "Toqo",
        TGA: "Tonqa",
        TRI: "Trinidad və Tobaqo",
        TUN: "Tunis",
        TUR: "Türkiyə",
        TKM: "Türkmənistan",
        TUV: "Tuvalu",
        UGA: "Uqanda",
        UKR: "Ukrayna",
        UAE: "BƏƏ",
        GBR: "Böyük Britaniya",
        USA: "ABŞ",
        URU: "Uruqvay",
        UZB: "Özbəkistan",
        VAN: "Vanuatu",
        VAT: "Vatikan",
        VEN: "Venesuela",
        VIE: "Vyetnam",
        YEM: "Yəmən",
        ZAM: "Zambiya",
        ZIM: "Zimbabve"
      },
    },
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: "en", // Default language
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
